
function Dia({ date, text, temperature_min, temperature_max, icon, wind, icon_wind, wind_direction, sunset, sunrise, humidity, moonset, moonrise, moon_phases_icon }) {

        const icono = 'https://v5i.tutiempo.net/wi/01/50/' + icon + '.png'
        const icono_viento = 'https://v5i.tutiempo.net/wd/big/black/' + icon_wind + '.png'
        const icono_luna = 'https://v5i.tutiempo.net/wmi/02/' + moon_phases_icon + '.png'

        let span = null
        const today = new Date()
        /////////////today.setMinutes(today.getMinutes() + today.getTimezoneOffset())
       /* const tomorrow =new Date()
        tomorrow.setDate(today.getDate() + 1)*/

        //const days = ['Domingo','Lunes','Martes','Miércoles','Jueves','Viernes','Sábado'];

        /*const getDia=(dia)=>{
               // const fecha=new Date(dia)
                return days[ new Date(dia).getDate() ];
        
        }*/
      

        const renderSwitch = (dia) => {
const fecha= new Date(dia)
fecha.setMinutes(fecha.getMinutes() + fecha.getTimezoneOffset())
console.log("ver ",fecha.getDay())
                switch (fecha.getDay()) {
                        case (0): return "Domingo"
                        case (1): return "Lunes"
                        case (2): return "Martes"
                        case (3): return "Miércoles"
                        case (4): return "Jueves"
                        case (5): return "Viernes"
                        case (6): return "Sábado"
                        default: return ""
                }
        }
  
        /*const addOneDayToDate = (date) => {
                date.setDate(date.getDate() + 1)

                return date
        }*/

        const datea = today.getFullYear() + '-' + parseInt(today.getMonth() + 1) + '-' + today.getDate()
      // const datemaniana = tomorrow.getFullYear() + '-' + parseInt(tomorrow.getMonth() + 1) + '-' + tomorrow.getDate()
       console.log('datea ',datea)
        //console.log('addOneDayToDate ',addOneDayToDate(new Date()))
        console.log('date ',new Date(date))

        if (datea === date) {
                span = (<><h3 className="date">

                        <span className="badge bg-danger rounded-pill">HOY</span> 
                        {renderSwitch(date)} {date.split("-")[2]}</h3>

               </> )
        }
        /*else if (datemaniana === date){
              //  console.log(datemaniana)
        span = (
                <span className="badge bg-danger rounded-pill">MAÑANA</span>
        )}*/
        else {
                span = (<><h3 className="date">
                        {renderSwitch(date)} {date.split("-")[2]}</h3>
                        </>)
        }
        return (
                <div className="daydata">

                                {span}

                        <p className="it"><img alt={text} title={text} height="45" src={icono} width="45" /> {temperature_max}&deg;C<br />{temperature_min}&deg;C</p>
                        <p className="wind"><img alt={wind_direction} title={wind_direction} height="35" src={icono_viento} width="35" />{wind}km/h</p>
                        <p className="oc">Humedad: {humidity}%<br />Salida sol: {sunrise}<br />Puesta sol: {sunset}</p>
                        <p className="moon"><img alt="" height="40" src={icono_luna} width="40" />Salida luna: {moonrise}<br />Puesta luna: {moonset}</p>
                </div>
        )


}
export default Dia;